import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import Graphic from "@arcgis/core/Graphic";
import PopupTemplate from "@arcgis/core/PopupTemplate";
import { AppConfig } from "../../../app.config";
import Collection from "@arcgis/core/core/Collection";
import { AppControllerService } from "../../../app-controller.service";
let SearchComponent = class SearchComponent {
    appController;
    constructor(appController) {
        this.appController = appController;
    }
    getCustomSources() {
        const sources = new Collection();
        if (AppConfig.settings.customGeolocators.length > 0) {
            AppConfig.settings.customGeolocators.forEach((geoLocator) => {
                this.addLocatorSource(geoLocator, sources);
            });
        }
        return sources;
    }
    searchMultipleResults(event, mapView) {
        const memoryCollection = [];
        const markerSymbol = this.createMarkerSymbol();
        const pointGraphics = [];
        // mapView.popup.clear();
        mapView.popup.close();
        // this.appController.showConsoleMessage("Results of the search: ", event);
        //   event.results.forEach((entry, index) => {
        //     entry.results.forEach((res) => {
        //       const [x, y] = this.determineCoordinate(res.feature.geometry);
        //
        //       memoryCollection[index] = [res.feature.attributes, res.feature.geometry, x, y, res.extent,
        //         res.feature.attributes.Loc_name, index, res.name];
        //
        //       const pointGraphic = this.createPointGraphic(markerSymbol, memoryCollection, index, res.feature.geometry.type);
        //       pointGraphics.push(pointGraphic);
        //     })
        //   })
        //
        //   if (memoryCollection.length > 0) {
        //     // @ts-ignore
        //     mapView.center = [memoryCollection[0][2], memoryCollection[0][3]];
        //     mapView.zoom = 11;
        //   }
    }
    createMarkerSymbol() {
        return {
            type: "simple-marker",
            color: [39, 111, 139],
            size: 15,
            outline: {
                color: [255, 255, 255],
                width: 2
            }
        };
    }
    determineCoordinate(geometry) {
        let x, y;
        if (geometry.type === "point") {
            x = geometry.longitude;
            y = geometry.latitude;
        }
        else {
            x = geometry.centroid.longitude;
            y = geometry.centroid.latitude;
        }
        return [x, y];
    }
    createPointGraphic(markerSymbol, memoryCollection, index, geometryType) {
        let geometry;
        if (geometryType === "point") {
            geometry = {
                type: "point",
                longitude: memoryCollection[index][2],
                latitude: memoryCollection[index][3]
            };
        }
        else {
            geometry = memoryCollection[index][1]; // Use the original geometry for non-point types
        }
        const template = new PopupTemplate({
            title: `${memoryCollection[index][7]}<div class='report-button' style='cursor: pointer' onclick='generateReport(${memoryCollection[index][2]}, ${memoryCollection[index][3]}, "${memoryCollection[index][7]}", ${memoryCollection[index][0].Postal})'><u><b><i>Generate Report</i></b></u></div>`
        });
        return new Graphic({
            geometry,
            symbol: markerSymbol,
            popupTemplate: template
        });
    }
    addLocatorSource(locatorSearchSource, searchSources) {
        searchSources.add({
            url: locatorSearchSource.url,
            name: locatorSearchSource.name,
            countryCode: locatorSearchSource.countryCode
        });
    }
    static ctorParameters = () => [
        { type: AppControllerService }
    ];
};
SearchComponent = __decorate([
    Injectable({
        providedIn: "root"
    })
], SearchComponent);
export { SearchComponent };
